var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Box from '../../box/Box';
import Text from '../../text';
function ReadOnly(_a) {
    var label = _a.label, value = _a.value, rest = __rest(_a, ["label", "value"]);
    return (React.createElement(Box, __assign({ border: "2px solid", borderColor: "grays.1", borderRadius: "4px", px: "11px", pt: "5px", pb: "9px" }, rest),
        React.createElement(Text, { fontSize: "14px", color: "grays.4", mb: "10px" }, label),
        React.createElement(Text, null, value)));
}
ReadOnly.defaultProps = {
    my: 2,
};
export default ReadOnly;
//# sourceMappingURL=ReadOnly.js.map